import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function deleteImageHardDelete(imageId: number): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.delete(`/images/${imageId}/hard-delete`);
  return response;
}

const useDeleteImageHardDelete = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['delete', `/images/:id/hard-delete`],
    mutationFn: (imageId: number) => deleteImageHardDelete(imageId),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default useDeleteImageHardDelete;
